export default String.raw`

{% include 'partials/common/date-format.html' -%}
{% assign discount = customer-profile.DiscountERPDetails -%}
{% assign pageQueryName = customer-profile.DiscountsERP.PageQueryGET -%}
{% assign queries = page.QueryString | Split: '&' -%}
{% for query in queries -%}
    {% if query contains 'page=' -%}
        {% assign pageQueryNo = query | Split: '=' | Last -%}
        {% break -%}
    {% else -%}
        {% assign pageQueryNo = 1 -%}
    {% endif -%}
{% endfor -%}

<div class="customer-submenu">
    <div class="customer-submenu__header">
        <div class="navigation-header">
            <button aria-label="{{translations.Back}}" class="pure-button load-first-lvl-js parent-container-reload-js" data-template="partials/customer-profile/discounts/discounts.html" data-url="{{ page.Url }}?tab=discounts">
                <svg aria-hidden="true" width="24" height="24">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#long-arrow-left-{{settings.iconStyle}}"></use>
                </svg>
            </button>
            {% if discount.Name != null -%}
                {{ discount.Name }}
            {% else -%}
                {{ translations.AllProducts }}
            {% endif -%}
        </div>
    </div>

    {% if discount.GlobalLimit != null or discount.RemainingGlobalLimit != null or discount.CustomerLimit != null or discount.RemainingCustomerLimit != null -%}
        <div class="details-info">
            <div class="details messages-container-js">
                {{discount.Description}}
            </div>

            <div class="details-info__summary discount-limit">
                <b>{{ translations.DiscountParameters }}</b>
                {% if discount.GlobalLimit != null -%}
                    <div class="row-summ">
                        <div class="title">{{ translations.DiscountGlobalLimit }}</div>
                        <b>{{ discount.GlobalLimit }}</b>
                    </div>
                {% endif -%}
                {% if discount.RemainingGlobalLimit != null -%}
                    <div class="row-summ">
                        <div class="title">{{ translations.DiscountRemainingGlobalLimit }}</div>
                        <b>{{ discount.RemainingGlobalLimit }}</b>
                    </div>
                {% endif -%}
                {% if discount.CustomerLimit != null -%}
                    <div class="row-summ">
                        <div class="title">{{ translations.DiscountCustomerLimit }}</div>
                        <b>{{ discount.CustomerLimit }}</b>
                    </div>
                {% endif -%}
                {% if discount.RemainingCustomerLimit != null -%}
                    <div class="row-summ">
                        <div class="title">{{ translations.DiscountRemainingCustomerLimit }}</div>
                        <b>{{ discount.RemainingCustomerLimit }}</b>
                    </div>
                {% endif -%}
            </div>
        </div>
    {% else -%}
        {% if discount.Description != '' and discount.Description != null  -%}
            <div class="message-container messages-container-js">
                {{discount.Description}}
            </div>
        {% endif -%}
    {% endif -%}

    {% if discount.Thresholds -%}
        {% for threshold in discount.Thresholds -%}
            <div class="details-info">
                <div class="details">
                    <div class="customer-info__content">
                        <div class="title">{{translations.Threshold}}: </div>
                        {% if threshold.ThresholdType == 1 -%}
                        <span>{{threshold.Threshold | ToPrice}} {{threshold.ThresholdSymbol}}</span>
                        {% else -%}
                        <span>{{threshold.Threshold}}</span>
                        {% endif -%}
                    </div>
                    <div class="customer-info__content">
                        <div class="title">{{translations.QuantityThreshold}}</div> 
                        <span>{{threshold.ThresholdMinPositionsCount}}</span>
                    </div>
                </div>
            </div>
            <div class="discount-elements-js">
                {% include 'partials/customer-profile/discounts/discount-elements.html' with threshold -%}
            </div>
        {% endfor -%}
    {% else -%}
    <div class="discount-elements-js">
        {% include 'partials/customer-profile/discounts/discount-elements.html' with discount -%}
    </div>
    {% endif -%}
</div>
<div class="during-ajax-modal-js during-ajax-modal hidden-js">
    <div class="loader big"></div>
</div>
`